import { render, staticRenderFns } from "./conversation-profile.vue?vue&type=template&id=237dd703&scoped=true"
import script from "./conversation-profile.vue?vue&type=script&lang=js"
export * from "./conversation-profile.vue?vue&type=script&lang=js"
import style0 from "./conversation-profile.vue?vue&type=style&index=0&id=237dd703&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237dd703",
  null
  
)

export default component.exports